export const genericComparison = (a, b) => {
  return a > b ? 1 : a < b ? -1 : 0;
}

export const randomId = () => {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}